import { render } from "./edit.vue?vue&type=template&id=82411658&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=82411658&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82411658"],['__file',"src/views/alfmeier/advertise/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82411658"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82411658', __exports__)) {
    console.log('reload')
    api.reload('82411658', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=82411658&scoped=true", () => {
    console.log('re-render')
    api.rerender('82411658', render)
  })

}


export default __exports__